// extracted by mini-css-extract-plugin
export var activeFilterButton = "_lg-c";
export var backButton = "_lg-4";
export var backIcon = "_lg-5";
export var chevronShortcut = "_lg-6";
export var container = "_lg-1";
export var editor = "_lg-8";
export var editorWrapper = "_lg-7";
export var prefix = "_lg-2";
export var searchIcon = "_lg-3";
export var suffix = "_lg-9";
export var suffixContent = "_lg-a";
export var suffixText = "_lg-b";
export var wrapper = "_lg-0";